import { render } from "./Formations.vue?vue&type=template&id=19018ae4&scoped=true"
import script from "./Formations.vue?vue&type=script&lang=js"
export * from "./Formations.vue?vue&type=script&lang=js"

import "./Formations.vue?vue&type=style&index=0&id=19018ae4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19018ae4"]])

export default __exports__